<template>
  <div v-loading="loading">
    <el-row class="margin-v3">
      <el-col :span="8">
        姓名：{{reportDetail.patientName}}
      </el-col>
      <el-col :span="8">
        性别：{{reportDetail.gender}}
      </el-col>
      <el-col :span="8">
        年龄：{{reportDetail.age}}岁
      </el-col>
    </el-row>
    <div class="dashed-line">
    </div>
    <el-row class="margin-v3">
      <el-col :span="12">
        开单科室：{{reportDetail.billDeptName}}
      </el-col>
      <el-col :span="12">
        开单医生：{{reportDetail.billDoctorName}}
      </el-col>
    </el-row>
    <el-row class="margin-v3">
      <el-col :span="12">
        报告单号：{{reportDetail.reportId}}
      </el-col>
      <el-col :span="12">
        执行科室：{{reportDetail.exeDeptName}}
      </el-col>
    </el-row>
    <div style="height: 5px;background-color: #f5f7f9"></div>
    <el-row style="padding-left: 5px;">
      <el-col :span="24" class="margin-v3">
        检查项目：{{reportDetail.projectName}}
      </el-col>
      <el-col :span="12" class="margin-v3">
        检查方法：{{reportDetail.jcMethod}}
      </el-col>
      <el-col :span="12" class="margin-v3">
        检查部位：{{reportDetail.jcPart}}
      </el-col>
      <el-col :span="24" class="margin-v3">
        开单时间：{{reportDetail.billTime}}
      </el-col>
      <el-col :span="24" class="margin-v3">
        检查时间：{{reportDetail.execTime}}
      </el-col>
      <el-col :span="24" class="margin-v3">
        报告时间：{{reportDetail.reportTime}}
      </el-col>
    </el-row>
    <div style="height: 5px;background-color: #f5f7f9"></div>
    <div style="min-height: 100px;">
      <span style="font-weight: bold">检查所见：</span>
      <span>{{reportDetail.jcSaw}}</span>
    </div>
    <div style="min-height: 100px;">
      <span style="font-weight: bold">诊断意见：</span>
      <span>{{reportDetail.diagnosis}}</span>
    </div>
    <div style="min-height: 100px;">
      <span style="font-weight: bold">建议：{{reportDetail.advice}}</span>
    </div>
    <div style="min-height: 100px;">
      <span style="font-weight: bold">备注：{{reportDetail.remark}}</span>
    </div>
  </div>
</template>

<script>
  import {getReportDetail} from "@/api/op/record";

  export default {
    props: {
      reportId: {
        type: String,
        default: "",
      },
      reportType: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        loading: false,
        reportDetail: {}
      }
    },
    watch: {
      reportId() {
        this.queryReportDetail();
      }
    },
    mounted() {
      this.queryReportDetail();
    },
    methods: {
      queryReportDetail() {
        this.loading = true;
        getReportDetail(this.reportId, this.reportType)
          .then((res) => {
            this.reportDetail = res.data.data;
            this.loading = false;
          }).finally(() => {
          this.loading = false;
        });
      }
    }
  }
</script>
<style lang="scss" scoped>
</style>
